
import { Component, Prop, Vue } from 'bits/vue'
import BaseIcon from 'vuecomponents/base_icon.vue'

@Component({
  components: { BaseIcon },
})
export default class extends Vue {
  @Prop({ type: String }) message!: string
  @Prop({ type: String }) actionText!: string
  @Prop({ type: String }) actionUrl!: string
  @Prop({ type: Boolean, default: false }) hasCloseButton!: boolean

  get hasLink(): boolean {
    return !!(this.actionText && this.actionUrl)
  }

  get hasAction(): boolean {
    return !!this.actionText && !this.actionUrl
  }
}
